import styled from "@emotion/styled";

export const DetailDataModalContainer = styled.div`
  width: 100%;
  padding : 10px 16px 25px 15px;
  margin: 0 auto;
`;